export default {
	documents: {
		previewError: {
			line1: 'Leider konnte keine Vorschau angezeigt werden.',
			line2: 'Bitte öffnen oder speichern Sie das Dokument!',
		},
		relatedFiles: 'Dateien zu dem Dokument',
		noFilesInContainer:
			'Es wurden noch keine Dateien in den Dokumentcontainern gefunden.',
		noFilesMatchSearch: 'Keine Dateien entsprechen Ihrer Suche',
		downloadAll: 'Alle herunterladen',
		selectAll: '@:common.selectAll',
		deselectAll: 'Alle auswählen',
		clearSelection: 'Auswahl aufheben',
		attachments: 'Anhänge',
		searchPlaceholder: 'Dateien durchsuchen...',
		sortBy: 'Sortieren nach',
		perPage: 'Pro Seite',
		showing: 'Zeige',
		of: 'von',
		groups: 'Gruppen',
		folders: 'Ordner',
		files: 'Dateien',
		noFolder: 'Ohne Ordner',
		noDocumentType: 'Kein Dokumenttyp',
		dropzone: {
			title: 'Dateien hier ablegen zum Hochladen',
			hint: 'Erlaubt: {types} — max. {maxSize} MB pro Datei',
		},
		view: {
			list: 'Listenansicht',
			container: 'Ordneransicht',
			grouped: 'Dokumentenarten',
		},
		tooltip: {
			list: 'Listenansicht',
			container: 'Ordneransicht',
			grouped: 'Dokumentenartansicht',
		},
		sort: {
			typeAsc: 'Dokumenttyp: A-Z',
			typeDesc: 'Dokumenttyp: Z-A',
			createdDesc: 'Neueste zuerst',
			createdAsc: 'Älteste zuerst',
			nameAsc: 'Name: A-Z',
			nameDesc: 'Name: Z-A',
		},
	},
}
